module.exports = __webpack_public_path__ + "static/media/hrbp_cover.5a035048.jpg";